import { render } from "./PolarChart.vue?vue&type=template&id=45ed8c95"
import script from "./PolarChart.vue?vue&type=script&lang=js"
export * from "./PolarChart.vue?vue&type=script&lang=js"
script.render = render

export default script